var DOMPurify = require('dompurify');
const noOp         = (val) => val;
const isDefined    = (val) => val !== undefined && val !== null && val !== '';
const isString     = (val) => typeof val === 'string';
const isArray      = (val) => isDefined(val) && Array.isArray(val);
const anyToBinary  = (val) => val ? 1 : 0;
const anyToBoolean = (val) => !!val;
const anyToString  = (val) => isDefined(val) ? `${val}` : '';
// when input type="number" handles most of the parsing:
const numTextToFloat   = (val) => isDefined(val) ? parseFloat(`${val}`) : '';
// parse float from input type="text":
// const textToFloat = (val) => isDefined(val) ? parseFloat(`${val}`.replace(/(?<!^)-?[^0-9,.]/g, '')) : '';

const anyToHtmlString  = (val) => { 
  if (!isDefined(val)) return "";
  val = val.replace(/[\u200B-\u200D\uFEFF]/g, '');
  return DOMPurify.sanitize(val, {USE_PROFILES: {html: true}});
};
const stringToArray = (val, {'control': {delimiter}}) => val && isString(val) ? val.split(delimiter) : [];
const arrayToString = (val, {'control': {delimiter}}) => isArray(val) ? val.join(delimiter) : '';

const fmtRelativeOffset = (val, {'control': {fmtDateDisplay, utcOffset}}) => {
  if (!isDefined(val)) return '';
  
  const signMultiplier = utcOffset.startsWith('-') ? -1 : 1;
  const utcOffsetMinutes = moment(utcOffset, 'hh:mm').hours() * 60 * signMultiplier;
  const relativeOffsetMinutes = moment().utcOffset() - utcOffsetMinutes;
  return moment.utc(val, ['x', fmtDateDisplay])
    .add(relativeOffsetMinutes, 'minutes')
    .format(fmtDateDisplay);
};

const fmtUtcOffset = (val, {'control': {fmtDateDisplay, utcOffset}}) => {
  if (!isDefined(val)) return '';

  return moment(val, ['x', fmtDateDisplay])
    .utcOffset(utcOffset)
    .format(fmtDateDisplay);
};

const fmtUtcDayStart = (val, {'control': {fmtDateDisplay}}) => {
  if (!isDefined(val)) return '';

  return moment(val, ['x', fmtDateDisplay])
    .utc()
    .startOf('d')
    .format(fmtDateDisplay);
};

const foreignRecordToKeyValue = (fRec, {control}) => {
  return (typeof fRec === 'object') ? fRec?.[control.foreignKey.keyFieldId]?.value || '' : fRec || '';
};

const FF = { 
  isDefined,
  noOp,
  anyToBinary,
  anyToBoolean,
  anyToString,
  anyToHtmlString,
  numTextToFloat,
  stringToArray,
  arrayToString,
  fmtUtcOffset,
  fmtRelativeOffset,
  foreignRecordToKeyValue,
  fmtUtcDayStart,
  // textToFloat,
};

export default FF;
